import { useRouteToFlowStartPage } from "./useRouteToFlowStartPage";
import { useFreyaSetup } from "./useFreyaSetup";
import { useLogEvent } from "../../../common/hooks/useLogEvent/useLogEvent";
import { useEffect } from "react";
import loggingUtils from "../../../common/utils/loggingUtils";
import { FREYA_REROUTE_LANDING_PAGE_TIMEOUT } from "../../../common/constants";
import { FailedScannedBadgeState } from "../../../common/types";

export const useFailedScanLogic = (state: FailedScannedBadgeState | null) => {
  const { routeToFlowStartPage } = useRouteToFlowStartPage();
  const { checkProducts, isLoading } = useFreyaSetup();
  const { logEvent } = useLogEvent();

  useEffect(() => {
    checkProducts();
    // Safely call logging function even with null state
    loggingUtils.logBadgePrintFailEvent(state, logEvent);
    const timeout = setTimeout(() => {
      routeToFlowStartPage();
    }, FREYA_REROUTE_LANDING_PAGE_TIMEOUT);
    return () => clearTimeout(timeout);
  }, []);

  return { isLoading, routeToFlowStartPage };
};
